/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { Badge, Table } from '@mantine/core'
import SelectableRow from '../../../client/js/components/selection/SelectableRow'
import { getRoleLink } from '../lib/roleLinks'
import AnchorLink from '../../../client/js/components/AnchorLink'

export type RoleListItemProps = {
  item: Role
}

function RoleListItem (props: RoleListItemProps) {
  const intl = useIntl()
  const { item } = props
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <AnchorLink to={getRoleLink(item.id)}>
          {item.name}
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        {item.system
          ? <Badge color="green">
            <FormattedMessage
              id="system"
              defaultMessage="Système"
            />
          </Badge>
          : <Badge color="blue">
            <FormattedMessage
              id="user"
              defaultMessage="Utilisateur"
            />
          </Badge>
        }
      </Table.Td>
      <Table.Td>
        {`${intl.formatDate(item.createdAt)} ${intl.formatTime(item.createdAt)}`}
      </Table.Td>
    </SelectableRow>
  )
}

export default RoleListItem
